import React from "react";
import "./CallToAction.css";

const CallToAction = () => (
  <div className="cta">
    <div className="cta-content">
      <p>Lets get to working!</p>
      <h3>Its not how we work, its about what we can offer.</h3>
    </div>
    <div className="cta-btn">
      <button type="button">Get Started</button>
    </div>
  </div>
);

export default CallToAction;
